import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import TeacherNav from './TeacherNav';
import TeacherSideNav from './TeacherSideNav';
import api from '../../utils/api';

const TeacherLayout = () => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [hasAssignments, setHasAssignments] = useState(false);

    useEffect(() => {
        const handle = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handle);
        api.get('/api/teacher/dashboard').then(res => {
            setHasAssignments(res.data?.stats?.totalAssignments > 0);
        }).catch(() => { });
        return () => window.removeEventListener('resize', handle);
    }, []);

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f0f7ff', fontFamily: "'Outfit', sans-serif" }}>
            <TeacherSideNav
                collapsed={sidebarCollapsed}
                isMobile={isMobile}
                onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
                hasAssignments={hasAssignments}
            />
            <div style={{
                flex: 1,
                marginLeft: isMobile ? 0 : (sidebarCollapsed ? 72 : 250),
                width: isMobile ? '100%' : `calc(100% - ${sidebarCollapsed ? 72 : 250}px)`,
                minHeight: '100vh', display: 'flex', flexDirection: 'column',
                transition: 'margin-left 0.3s cubic-bezier(0.4,0,0.2,1)', minWidth: 0,
            }}>
                <TeacherNav onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} isMobile={isMobile} />
                <main style={{ flex: 1, padding: isMobile ? '12px 12px 80px' : '28px 36px 32px', boxSizing: 'border-box', width: '100%' }}>
                    <Outlet context={{ hasAssignments }} />
                </main>
            </div>
        </div>
    );
};

export default TeacherLayout;
